// Generated by scripts/mdi/import-questionnaires.mjs from MDI "BPC-157 / Thymosin beta 4 09.17.26" (8d56cb60-fef9-4c63-a9b5-5fefcc3da8a7). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiBPC157ThymosinBeta4AnswerField } from './questions';

export const mdiBPC157ThymosinBeta4: FormType<mdiBPC157ThymosinBeta4AnswerField> =
  {
    name: 'BPC-157 / Thymosin beta 4',
    validityLength: 25,
    questions: [
      {
        key: 'mdiBPC157ThymosinBeta4_sex',
        next: {
          switch: [
            {
              condition: { 'mdiBPC157ThymosinBeta4_sex.female': true },
              key: 'mdiBPC157ThymosinBeta4_pregnancy'
            },
            {
              condition: { 'mdiBPC157ThymosinBeta4_pregnancy.yes': true },
              key: 'mdiBPC157ThymosinBeta4_wereSorryTreatmentNotMedically'
            }
          ],
          els: 'mdiBPC157ThymosinBeta4_importantClickAttachedLinkReview'
        }
      },
      {
        key: 'mdiBPC157ThymosinBeta4_pregnancy',
        next: {
          condition: { 'mdiBPC157ThymosinBeta4_pregnancy.yes': true },
          key: 'mdiBPC157ThymosinBeta4_wereSorryTreatmentNotMedically',
          els: 'mdiBPC157ThymosinBeta4_importantClickAttachedLinkReview'
        }
      },
      'mdiBPC157ThymosinBeta4_wereSorryTreatmentNotMedically',
      'mdiBPC157ThymosinBeta4_importantClickAttachedLinkReview',
      'mdiBPC157ThymosinBeta4_reasonInterestedPeptide',
      {
        key: 'mdiBPC157ThymosinBeta4_everUsedPeptideTherapiesPast',
        next: {
          condition: {
            'mdiBPC157ThymosinBeta4_everUsedPeptideTherapiesPast.yes': true
          },
          key: 'mdiBPC157ThymosinBeta4_peptidesUsedPreviously',
          els: 'mdiBPC157ThymosinBeta4_everReactionSideEffectsPeptide'
        }
      },
      'mdiBPC157ThymosinBeta4_peptidesUsedPreviously',
      {
        key: 'mdiBPC157ThymosinBeta4_everReactionSideEffectsPeptide',
        next: {
          condition: {
            'mdiBPC157ThymosinBeta4_everReactionSideEffectsPeptide.yes': true
          },
          key: 'mdiBPC157ThymosinBeta4_reactionSideEffect',
          els: 'mdiBPC157ThymosinBeta4_diagnosedRedFlagMedicalConditions'
        }
      },
      'mdiBPC157ThymosinBeta4_reactionSideEffect',
      'mdiBPC157ThymosinBeta4_diagnosedRedFlagMedicalConditions',
      'mdiBPC157ThymosinBeta4_confirmNotHistoryCancerKidney',
      'mdiBPC157ThymosinBeta4_takeRedFlagMedicationsSubstances',
      'mdiBPC157ThymosinBeta4_allergyBenzylPeroxide',
      'mdiBPC157ThymosinBeta4_lastTimePersonMedicalEvaluation',
      'mdiBPC157ThymosinBeta4_confirmUnderstandContactDoctorQuestions',
      'mdiBPC157ThymosinBeta4_firstMessageDoctor',
      'mdiBPC157ThymosinBeta4_complete'
    ]
  };
